import React from 'react';
import { Mail, Phone, MapPin, Globe } from 'lucide-react';
import { Section } from './ui/Section';
export function ContactSection() {
  return <footer className="bg-navy text-white py-16 page-break-inside-avoid" data-id="element-17">
      <div className="container mx-auto px-8" data-id="element-18">
        <div className="grid md:grid-cols-2 gap-12 mb-12" data-id="element-19">
          <div data-id="element-20">
            <h2 className="text-3xl font-bold font-serif mb-6" data-id="element-21">
              Ready to Transform Your TVET System?
            </h2>
            <p className="text-gray-400 text-lg mb-8 leading-relaxed" data-id="element-22">
              Contact us today to discuss how we can support your TVET
              modernisation goals through quality assurance,
              internationalisation, green transition, and digitalisation.
            </p>

            <div className="space-y-4" data-id="element-23">
              <div className="flex items-center gap-4 text-gray-300" data-id="element-24">
                <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gold flex-shrink-0" data-id="element-25">
                  <Mail className="w-5 h-5" data-id="element-26" />
                </div>
                <div data-id="element-27">
                  <div className="text-sm text-gray-500" data-id="element-28">Email</div>
                  <div data-id="element-29">info@londonbas.co.uk</div>
                </div>
              </div>
              <div className="flex items-center gap-4 text-gray-300" data-id="element-30">
                <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gold flex-shrink-0" data-id="element-31">
                  <Phone className="w-5 h-5" data-id="element-32" />
                </div>
                <div data-id="element-33">
                  <div className="text-sm text-gray-500" data-id="element-34">Phone</div>
                  <div data-id="element-35">+44 (0) 20 1234 5678</div>
                </div>
              </div>
              <div className="flex items-center gap-4 text-gray-300" data-id="element-36">
                <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gold flex-shrink-0" data-id="element-37">
                  <MapPin className="w-5 h-5" data-id="element-38" />
                </div>
                <div data-id="element-39">
                  <div className="text-sm text-gray-500" data-id="element-40">Address</div>
                  <div data-id="element-41">London, United Kingdom</div>
                </div>
              </div>
              <div className="flex items-center gap-4 text-gray-300" data-id="element-42">
                <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gold flex-shrink-0" data-id="element-43">
                  <Globe className="w-5 h-5" data-id="element-44" />
                </div>
                <div data-id="element-45">
                  <div className="text-sm text-gray-500" data-id="element-46">Website</div>
                  <div data-id="element-47">www.londonbas.co.uk</div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white/5 p-8 border border-white/10" data-id="element-48">
            <h3 className="text-2xl font-bold font-serif mb-6" data-id="element-49">
              Our TVET Methodology
            </h3>
            <div className="space-y-6" data-id="element-50">
              <div data-id="element-51">
                <div className="flex items-center gap-3 mb-2" data-id="element-52">
                  <div className="w-8 h-8 bg-gold text-navy font-bold flex items-center justify-center text-sm" data-id="element-53">
                    1
                  </div>
                  <h4 className="font-bold" data-id="element-54">Assess</h4>
                </div>
                <p className="text-sm text-gray-400 ml-11" data-id="element-55">
                  Comprehensive needs analysis and context mapping
                </p>
              </div>
              <div data-id="element-56">
                <div className="flex items-center gap-3 mb-2" data-id="element-57">
                  <div className="w-8 h-8 bg-gold text-navy font-bold flex items-center justify-center text-sm" data-id="element-58">
                    2
                  </div>
                  <h4 className="font-bold" data-id="element-59">Design</h4>
                </div>
                <p className="text-sm text-gray-400 ml-11" data-id="element-60">
                  Tailored solutions aligned with international standards
                </p>
              </div>
              <div data-id="element-61">
                <div className="flex items-center gap-3 mb-2" data-id="element-62">
                  <div className="w-8 h-8 bg-gold text-navy font-bold flex items-center justify-center text-sm" data-id="element-63">
                    3
                  </div>
                  <h4 className="font-bold" data-id="element-64">Implement</h4>
                </div>
                <p className="text-sm text-gray-400 ml-11" data-id="element-65">
                  Practical delivery with capacity building support
                </p>
              </div>
              <div data-id="element-66">
                <div className="flex items-center gap-3 mb-2" data-id="element-67">
                  <div className="w-8 h-8 bg-gold text-navy font-bold flex items-center justify-center text-sm" data-id="element-68">
                    4
                  </div>
                  <h4 className="font-bold" data-id="element-69">Monitor</h4>
                </div>
                <p className="text-sm text-gray-400 ml-11" data-id="element-70">
                  Progress tracking and quality assurance
                </p>
              </div>
              <div data-id="element-71">
                <div className="flex items-center gap-3 mb-2" data-id="element-72">
                  <div className="w-8 h-8 bg-gold text-navy font-bold flex items-center justify-center text-sm" data-id="element-73">
                    5
                  </div>
                  <h4 className="font-bold" data-id="element-74">Improve</h4>
                </div>
                <p className="text-sm text-gray-400 ml-11" data-id="element-75">
                  Continuous enhancement and sustainability planning
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center" data-id="element-76">
          <div className="font-serif font-bold text-2xl mb-2" data-id="element-77">
            London Bridge Academic Services
          </div>
          <div className="text-gold italic mb-4" data-id="element-78">
            TVET Services & Skills Transformation
          </div>
          <p className="text-sm text-gray-500" data-id="element-79">
            © {new Date().getFullYear()} London Bridge Academic Services. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}